import { RootState } from '@beam-app/types';
import { addKnownStatus } from '@store/redux/features/inventory/knownData';
import { useAppDispatch } from '@store/redux/store';
import { pick } from '@utils/pick';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { EquipmentStatusSelector } from '../EquipmentStatusSelector';
import { GlobalHeader, InputDiv, InputList } from '../styles';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew } from './utils';

type StatusGroupProps = PropsInputGlobal<'equipmentStatusId'>;

export function StatusGroup(props: StatusGroupProps) {
  const { setFormV, equipmentStatusId, setGlobalFormV } = props;

  const dispatch = useAppDispatch();
  const knownStatuses = useSelector(
    (state: RootState) => state.knownData.knownStatuses,
  );
  const statusFilled = knownStatuses[equipmentStatusId ?? ''];
  return (
    <InputList>
      <InputDiv>
        <GlobalHeader>Status</GlobalHeader>
        <EquipmentStatusSelector
          equipmentStatus={statusFilled}
          onClickStatus={input => {
            dispatch(addKnownStatus(pick(input, ['name', 'id', 'category'])));
            onChangeGlobal('equipmentStatusId', input.id, setGlobalFormV);
            setForAllNew('equipmentStatusId', input.id, setFormV);
          }}
        />
      </InputDiv>
    </InputList>
  );
}
export default memo(StatusGroup);
